import { FooterSVG } from 'components/svgs/Footer.svg'

export interface FooterProps {
  className?: string
}

export const Footer = (props: FooterProps) => {
  const { className } = props

  return (
    <footer className={className}>
      <FooterSVG />
    </footer>
  )
}
